import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { FullPageState } from "./components/ui";
import { useAuth } from "./lib/auth";
import { AutomationPage } from "./pages/AutomationPage";
import { BusinessContextPage } from "./pages/BusinessContextPage";
import { CommentsPage } from "./pages/CommentsPage";
import { ConnectionsPage } from "./pages/ConnectionsPage";
import { ContentPage } from "./pages/ContentPage";
import { HomePage } from "./pages/HomePage";
import { InboxPage } from "./pages/InboxPage";
import { LoginPage } from "./pages/LoginPage";
import { SettingsPage } from "./pages/SettingsPage";

export function App() {
  const { status } = useAuth();

  if (status === "loading") {
    return <FullPageState title="Opening AutoSocial" body="Checking the secure owner session…" />;
  }

  if (status === "signed_out") {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="content" element={<ContentPage />} />
        <Route path="comments" element={<CommentsPage />} />
        <Route path="inbox" element={<InboxPage />} />
        <Route path="business-context" element={<BusinessContextPage />} />
        <Route path="automation" element={<AutomationPage />} />
        <Route path="connections" element={<ConnectionsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

